<template>
  <div class="according-month">

    <div class="according-month-header">
      <el-form :inline="true"
               :model="accordingMonthForm"
               ref="accordingMonthFormRef">

        <el-form-item label="员工账号："
                      :label-width="labelWidth">
          <el-input v-model="accordingMonthForm.phone"
                    @input="searchList"
                    clearable
                    placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="员工姓名："
                      :label-width="labelWidth">
          <el-input v-model="accordingMonthForm.recommender_name"
                    @input="searchList"
                    clearable
                    placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="工号："
                      :label-width="labelWidth">
          <el-input v-model="accordingMonthForm.recommender_code"
                    @input="searchList"
                    clearable
                    placeholder="请输入"></el-input>
        </el-form-item>

        <el-form-item label="时间："
                      :label-width="labelWidth">
          <el-date-picker v-model="accordingMonthForm.time_date"
                          type="monthrange"
                          align="right"
                          unlink-panels
                          format="yyyy-MM"
                          value-format="yyyy-MM"
                          range-separator="至"
                          start-placeholder="开始月份"
                          end-placeholder="结束月份"
                          @change="searchList"
                          :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     size="small"
                     @click="searchList">查询</el-button>
          <el-button size="small"
                     @click="resetBtn">重置</el-button>
        </el-form-item>

      </el-form>
      <div class="fun-point">
        <el-button type="primary"
                   :disabled="module_id_array[0]? !module_id_array.includes('649'): false"
                   @click="outData">导出Excel</el-button>
      </div>
    </div>

    <div class="month-and-staff-body">
      <el-table v-loading="tableLoading"
                ref="monthTableRef"
                :data="monthTable"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }">

        <el-table-column v-for="item in tableHeader"
                         :key="item.prop"
                         :prop="item.prop"
                         :label="item.label"
                         :width="item.width">

          <template slot-scope="scope">
            <div v-if="item.prop == 'date'">
              {{ scope.row[item.prop] | dateFormat  }}
            </div>
            <div v-else>{{ scope.row[item.prop] }}</div>
          </template>

        </el-table-column>

      </el-table>
      <!-- 分页 -->
      <pagination v-show="totalNum>0"
                  :total="totalNum"
                  :page.sync="pagination.page"
                  :limit.sync="pagination.pageNumber"
                  @pagination="getList" />
    </div>
  </div>
</template>

<script>
import staff from '../../../../api/staff';
import Pagination from '@/components/Pagination/index.vue';
export default {
  components: {
    Pagination
  },
  data() {
    return {
      totalNum: 0,
      pagination: {
        page: 1,
        pageNumber: 10
      },
      labelWidth: '100px',
      accordingMonthForm: {
        phone: '',
        recommender_name: '',
        recommender_code: '',
        time_date: ''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            }
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      tableHeader: [
        { prop: 'date', label: '时间', width: 'auto' },
        { prop: 'transaction_money', label: '未扎帐提成（元）', width: 'auto' },
        { prop: 'no_get_money', label: '不可提成（元）', width: 'auto' },
        { prop: 'get_money', label: '已可提成（元）', width: 'auto' },
        { prop: 'ready_money', label: '待审批提成（元）', width: 'auto' },
        { prop: 'done_money', label: '已提成（元）', width: 'auto' }
      ],
      monthTable: []
    };
  },
  filters: {
    dateFormat(date) {
      return date.slice(0, 4) + '-' + date.slice(4);
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.tableLoading = true;
      let params = Object.assign(this.pagination, this.accordingMonthForm);
      if (params.time_date) {
        params['time_date_start'] = params.time_date[0];
        params['time_date_end'] = params.time_date[1];
      } else {
        params['time_date_start'] = '';
        params['time_date_end'] = '';
      }
      staff.getDateProportionManageList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          let info = {
            total_transaction_money: data.total_transaction_money,
            total_no_get_money: data.total_no_get_money,
            total_get_money: data.total_get_money,
            total_ready_money: data.total_ready_money,
            total_money: data.total_money
          };
          this.$emit('getInfo', info);
          this.monthTable = data.list;
          this.totalNum = data.total;
          this.tableLoading = false;
        }
      });
    },
    searchList() {
      this.pagination.page = 1;
      this.getList();
    },
    resetBtn() {
      for (let key in this.accordingMonthForm) {
        this.accordingMonthForm[key] = '';
      }
      this.getList();
    },
    outData() {
      let params = Object.assign(this.accordingMonthForm);
      if (params.time_date) {
        params['time_date_start'] = params.time_date[0];
        params['time_date_end'] = params.time_date[1];
      } else {
        params['time_date_start'] = '';
        params['time_date_end'] = '';
      }
      staff.exportDateProportionManageList(params).then((res) => {
        let { code, data } = res;
        if (code == 0) {
          window.open(data.url);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.according-month {
  .according-month-header {
    .el-form {
      display: flex;
      flex-wrap: wrap;
    }
    .fun-point {
      text-align: left;
      margin-bottom: 10px;
    }
  }
}
</style>